import { createClient } from 'contentful';

class ContentfulService {
  constructor() {
    this.client = createClient({
      space: process.env.CONTENTFUL_SPACE,
      accessToken: process.env.CONTENTFUL_ACCESS_KEY,
    });
  }

  flattenResponse(response) {
    return response.items.map((item) => ({
      ...item.fields,
      id: item.sys.id,
      sections: item.fields.sections ? item.fields.sections.map((section) => ({
        ...section.fields,
        type: section.sys.contentType.sys.id,
      })) : [],
    }));
  }

  async getColumns() {
    const response = await this.client.getEntries({
      content_type: 'service',
    });

    return this.flattenResponse(response);
  }

  async getPages() {
    const response = await this.client.getEntries({
      content_type: 'page',
    });

    return this.flattenResponse(response);
  }
}

export default new ContentfulService();
